import cx from "classnames";
import dynamic from "next/dynamic";
import Link from "next/link";
import { useRouter } from "next/router";
import { useMemo, useState } from "react";
import { TailSpin } from "react-loader-spinner";
import useSticky from "../../../../../utils/useSticky";
import AvailableTomorrow from "../AvailableTomorrow";
const Price = dynamic(() => import("../../../../Atoms/Price"), { ssr: false });

interface Props {
  topOffset: number;
  stopEl: any;
  children: any;
}

export function StickyBottomBar({ topOffset, stopEl, children }: Props) {
  const isSticky = useSticky(topOffset, stopEl);
  const classNames = cx({
    "mui-detailStickyContainer": true,
    "mui-detailStickyContainerShow": isSticky,
  });

  return <div className={classNames}>{children}</div>;
}

interface BarProps {
  name: string;
  productId: string;
  isAvailable: boolean;
}

export function BotBar({ name, isAvailable, productId }: BarProps) {
  const [showLoader, setShowLoader] = useState(false);
  const router = useRouter();
  const query = useMemo(() => {
    const query = { ...router.query };
    delete query["id"];
    return query;
  }, [router.query]);

  return (
    <div className="AppTopBar">
      <div className="AppLayout">
        <div className="TopBarDetailInner">
          <h3>{name}</h3>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Price id={productId} />
            <AvailableTomorrow productId={productId} />
          </div>

          <Link
            href={{
              pathname: `/checkout/${router.query.id}`,
              query,
            }}
            onClick={() => setShowLoader(true)}
          >
            <button className="Button" disabled={!isAvailable}>
              {showLoader ? (
                <TailSpin
                  color="#FFFFFF"
                  height={18}
                  width={18}
                  ariaLabel="tail-spin-loading"
                />
              ) : (
                "Select Dates"
              )}
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}
